const KEY_XEROINVSYNCDATE = "XeroInvoiceLastSyncDate";
const KEY_XEROCREDSYNCDATE = "XeroCreditNoteLastSyncDate";
const KEY_DOCFILEREADSYNCDATE = "DocumentFileReaderLastSyncDate";
const KEY_XEROIGNORECONTACTS = "XeroIgnoreContacts";
const KEY_XEROPOWPURCHASECONTACTS = "XeroPowderPurchaseContacts";
const KEY_XEROPURCHORDERSYNCDATE = "XeroPurchaseOrderLastSyncDate";
const KEY_DAILYTARGETPRODUCTION = "DailyTargetProduction";
const KEY_DAILYTARGETRECEIVED = "DailyTargetReceived";
const KEY_DAILYTARGETINVOICE = "DailyTargetInvoice";

export default {
    KEY_XEROINVSYNCDATE,
    KEY_XEROCREDSYNCDATE,
    KEY_DOCFILEREADSYNCDATE,
    KEY_XEROIGNORECONTACTS,
    KEY_XEROPOWPURCHASECONTACTS,
    KEY_XEROPURCHORDERSYNCDATE,
    KEY_DAILYTARGETPRODUCTION,
    KEY_DAILYTARGETRECEIVED,
    KEY_DAILYTARGETINVOICE,
    systemSettings: [
        {
            code: KEY_XEROPURCHORDERSYNCDATE,
            label: 'Xero Purchase Order Last Sync Date',
            type: 'date',
        },
        {
            code: KEY_XEROPOWPURCHASECONTACTS,
            label: 'Xero Powder Purchase Contacts',
            type: 'text',
            help: 'Comma seperate Xero names that you would like to ignore.'
        },
        {
            code: KEY_XEROINVSYNCDATE,
            label: 'Xero Invoice Last Sync Date',
            type: 'date',
        },
        {
            code: KEY_XEROCREDSYNCDATE,
            label: 'Xero Credit Note Last Sync Date',
            type: 'date',
        },
        {
            code: KEY_DOCFILEREADSYNCDATE,
            label: 'Document File Reader Last Sync Date',
            type: 'date',
        },
        {
            code: KEY_XEROIGNORECONTACTS,
            label: 'Xero Ignore Contacts',
            type: 'text',
            help: 'Comma seperate Xero names that you would like to ignore.'
        },
        {
            code: KEY_DAILYTARGETPRODUCTION,
            label: 'Daily Production Target',
            type: 'number',
            help: 'The daily production target value.'
        },
        {
            code: KEY_DAILYTARGETRECEIVED,
            label: 'Daily Received Target',
            type: 'number',
            help: 'The daily received target value.'
        },
        {
            code: KEY_DAILYTARGETINVOICE,
            label: 'Daily Invoice Target',
            type: 'number',
            help: 'The daily invoice target value.'
        },
    ],
};